import React from 'react';
import { observer } from 'mobx-react-lite';
import { Spin } from 'antd';

export const withLoading = WrappedComponent => {
  return observer(({ loading = false, loadingTip = '加载中...', ...props }) => {
    return (
      <Spin spinning={loading} tip={loadingTip}>
        <WrappedComponent {...props} />
      </Spin>
    );
  });
};
